module.exports = __webpack_public_path__ + "img/31_34.c96f2df5.png";